import type { TurnstileRenderContainer } from './types'

export const resolveContainerElement = (container: TurnstileRenderContainer): HTMLElement | null => {
  if (typeof container === 'string') {
    return document.querySelector(container)
  }
  return container
}
